// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"753c84c2","1032":"c6c03418","2207":"471cbd10","2544":"e6500cdd","3179":"4cd1c492","3964":"02896b79","4884":"a45a1701","5693":"bebd5181","9756":"c0ddd44f","9985":"73317ef0"}[chunkId] + ".chunk.css";
};